export const configDefault = {
    layoutSettings: {
        layoutType: {
            title: '谱书类型',
            value: 0,
            select: [
                {
                    name: '欧式',
                    value: 0,
                    detail: '欧阳修式家谱格式的特点是：世代分格，由右向左排列，欧式中，每个世代人名左侧可有一些生平记述，主要介绍该人的字、号、功名、官爵、生辰年月日、配偶、藏地、功绩等。'
                },
                {
                    name: '牒记式',
                    value: 1,
                    detail: '不用横竖线连接世代人名间的关系，而是纯用文字来表达这种关系；每个人名下都有一个相关的简介。牒记式的世系形式固定，次序分明，比较节约纸张。'
                },
                {
                    name: '宝塔式',
                    value: 2,
                    detail: ''
                },
                {
                    name: '苏式',
                    value: 3,
                    detail: '又称垂珠体，是北宋文学家苏洵创立的。苏式世系表特点是：世代间直行下垂，图表格式也是由右向左排列的，主要是强调宗法关系。'
                },
                {
                    name: '现代表格式',
                    value: 4,
                    detail: '以现代书籍阅读习惯及设计风格，对世系、行传进行排版设计,符合现代人从左至右的阅读习惯。'
                },
                {
                    name: '宝塔大图',
                    value: 5,
                    detail: ''
                }
            ]
        },
        searchTable: {
            title: '显示检索表',
            value: 0,
            select: [
                { name: '显示', value: 0 },
                { name: '不显示', value: 1 }
            ]
        },
        searchType: {
            title: '吊线图类型',
            value: 0,
            select: [
                { name: '竖排', value: 0 },
                { name: '竖排居中', value: 1 },
                { name: '横排', value: 2 },
                { name: '不显示', value: 3 }
            ]
        },
        searchPedigree: {
            title: '吊线图世系数',
            value: 0,
            select: [
                { name: '五世', value: 0 },
                { name: '十世', value: 1 }
            ]
        },
        sagasShow: {
            title: '显示行传',
            value: 0,
            select: [
                { name: '显示', value: 0 },
                { name: '不显示', value: 1 }
            ]
        },
        direction: {
            title: '开向',
            value: 0,
            select: [
                { name: '左开', value: 0 },
                { name: '右开', value: 1 }
            ]
        },
        header: {
            title: '页眉样式',
            value: 0,
            select: [
                { name: '经典', value: 0 },
                { name: '经典二', value: 1 },
                { name: '经典三', value: 2 },
                { name: '筒子页', value: 3 }
            ]
        },
        binding: {
            title: '装订方式',
            value: 0,
            select: [
                { name: '正度16开(185mm*260mm)', value: 0 },
                { name: '大度16开(210mm*285mm)', value: 1 },
                { name: '旧版(190mm*275mm)', value: 2 }
            ]
        },
        bleed: {
            title: '出血位',
            value: 1
        },
        outlineShow: {
            title: '显示行传详情',
            value: 0,
            select: [
                { name: '显示', value: 0 },
                { name: '不显示', value: 1 }
            ]
        },
        expand: {
            title: '收缩排版',
            value: 0,
            select: [
                { name: '收缩', value: 0 },
                { name: '半收缩', value: 1 },
                { name: '全展开', value: 2 },
                { name: '左对齐全展开', value: 3 }
            ]
        },
        lineColor: {
            title: '线条颜色',
            value: 0,
            select: [
                { name: '黑色', value: 0 },
                { name: '红色', value: 1 },
                { name: '彩色', value: 2 }
            ]
        },
        pendant: {
            title: '吊坠图案',
            value: 0,
            select: [
                { name: '无', value: 0 },
                { name: '圆圈', value: 1 },
                { name: '葫芦', value: 2 }
            ]
        },
        pendantType: {
            title: '吊坠样式',
            value: 0,
            select: [
                { name: '全部显示空心', value: 0 },
                { name: '全部显示实心', value: 1 },
                { name: '过世显示空心', value: 2 },
                { name: '过世显示实心', value: 3 }
            ]
        },
        spouseDead: {
            title: '显示配偶生殁标记',
            value: 0,
            select: [
                { name: '殁', value: 0 },
                { name: '不显示', value: 1 }
            ]
        },
        spectrumShow: {
            title: '显示世系数',
            value: 0,
            select: [
                { name: '侧边显示', value: 0 },
                { name: '不显示', value: 1 }
            ]
        },
        rankShow: {
            title: '显示排行',
            value: 0,
            select: [
                { name: '显示', value: 0 },
                { name: '不显示', value: 1 }
            ]
        },
        nameFontSize: {
            title: '名字字号',
            value: 0,
            select: [
                { name: '18号(默认)', value: 0 },
                { name: '24号', value: 1 },
                { name: '32号', value: 2 },
                { name: '自定义', value: 3 }
            ]
        },
        contentFontSize: {
            title: '正文字号',
            value: 0,
            select: [
                { name: '12号(默认)', value: 0 },
                { name: '18号', value: 1 },
                { name: '22号', value: 2 },
                { name: '自定义', value: 3 }
            ]
        },
        rankFontSize: {
            title: '排行字号',
            value: 0,
            select: [
                { name: '12号(默认)', value: 0 },
                { name: '18号', value: 1 },
                { name: '22号', value: 2 },
                { name: '自定义', value: 3 }
            ]
        },
        topFont: {
            title: '顶部文字放大',
            value: 0,
            select: [
                { name: '不放大', value: 0 },
                { name: '前3世', value: 1 },
                { name: '前5世', value: 2 },
                { name: '前7世', value: 3 },
                { name: '前10世', value: 4 }
            ]
        }
    },
    commonSettings: {
        language: {
            title: '系统关键字语言',
            value: 0,
            select: [
                { name: '简体中文', value: 0 },
                { name: '繁体中文', value: 1 }
            ]
        },
        languageChange: {
            title: '简繁转换',
            value: 0,
            select: [
                { name: '转繁体', value: 0 },
                { name: '转简体', value: 1 },
                { name: '不转换', value: 2 }
            ]
        },
        nameShowType: {
            title: '姓名显示',
            value: 0,
            select: [
                { name: '仅显示谱名', value: 0 },
                { name: '显示全名(显示手动录入的姓 + 名)', value: 1 },
                { name: '自动显示全名(未录入时自动使用谱系姓氏)', value: 2 },
                { name: '单名字显示姓', value: 3 },
                { name: '单名字加公或加姓(过世加公)', value: 4 }
            ]
        },
        pedigreeRule: {
            title: '世系数规则',
            value: 0,
            select: [
                { name: '从第一个人物递增', value: 0 },
                { name: '以每代第一个人为准', value: 1 },
                { name: '自动判断(取多数人)', value: 2 }
            ]
        },
        pedigreeShowMode: {
            title: '世系显示格式',
            value: 0,
            select: [
                { name: 'N世', value: 0 },
                { name: '第N世', value: 1 },
                { name: '世次N', value: 2 }
            ]
        },
        twentyShow: {
            title: '使用廿/卅代替二十/三十',
            value: 0,
            select: [
                { name: '是', value: 0 },
                { name: '否', value: 1 }
            ]
        },
        titleMode: {
            title: '世系标题样式',
            value: 0,
            select: [
                { name: '样式一', value: 0 },
                { name: '样式二', value: 1 }
            ]
        }
    },
    showSettings: {
        spouseShow: {
            title: '配偶显示',
            value: 0,
            select: [
                { name: '独立显示(独占一列)', value: 0 },
                { name: '行传显示(显示在行传描述, 不换行)', value: 1 },
                { name: '不显示', value: 2 },
                { name: '非入赘男性配偶行传显示', value: 3 }
            ]
        },
        sonShow: {
            title: '祧子显示',
            value: 0,
            select: [
                { name: '完整显示后代(同生父)', value: 0 },
                { name: '简洁显示后代(不显示配偶及行传)', value: 1 },
                { name: '世系图显示(世系表中不显示)', value: 2 },
                { name: '不显示后代', value: 3 }
            ]
        },
        daughterShow: {
            title: '女儿显示',
            value: 0,
            select: [
                { name: '立传显示(同儿子一样)', value: 0 },
                { name: '仅招婿立传', value: 1 },
                { name: '未婚和招婿立传', value: 2 },
                { name: '仅列表显示(在父母的生子列表中)', value: 3 },
                { name: '仅行传显示(在父母的行传中)', value: 4 },
                { name: '不显示', value: 5 }
            ]
        },
        daughterDescShow: {
            title: '女儿后代显示',
            value: 0,
            select: [
                { name: '完整显示(立传)', value: 0 },
                { name: '仅招婿后代完整显示(立传)', value: 1 },
                { name: '仅描述显示(不立传)', value: 2 },
                { name: '不显示', value: 3 }
            ]
        },
        avatarShow: {
            title: '头像显示（适用于欧式/苏式/牒记式）',
            value: 0,
            select: [
                { name: '自动并列(只有一个配偶时并列显示)', value: 0 },
                { name: '单独显示(头像显示在对应名字后面)', value: 1 },
                { name: '不显示', value: 2 }
            ]
        },
        firstShow: {
            title: '抽头显示',
            value: 0,
            select: [
                { name: '全部显示', value: 0 },
                { name: '第一个孩子显示', value: 1 },
                { name: '不显示', value: 2 }
            ]
        },
        noBiographyShow: {
            title: '无行传内容的成员',
            value: 0,
            select: [
                { name: '立传', value: 0 },
                { name: '男性立传', value: 1 },
                { name: '女性立传', value: 2 },
                { name: '不立传', value: 3 }
            ]
        },
        displayNoneShow: {
            title: '设为隐藏的后代',
            value: 0,
            select: [
                { name: '完全不显示(就当没有这个孩子)', value: 0 },
                { name: '在列表显示(不立传)', value: 1 }
            ]
        },
        spouseShowWord: {
            title: '显示配偶关系',
            value: 0,
            select: [
                { name: '显示(娶某某 / 配某某)', value: 0 },
                { name: '不显示(只显示配偶名字)', value: 1 }
            ]
        },
        addressShow: {
            title: '显示现居地',
            value: 0,
            select: [
                { name: '显示', value: 0 },
                { name: '不显示', value: 1 }
            ]
        },
        spouseAddressShow: {
            title: '显示配偶现居地',
            value: 0,
            select: [
                { name: '显示', value: 0 },
                { name: '不显示', value: 1 }
            ]
        }
    },
    catalogueSettings: {
        title: {
            title: '显示索引目录',
            value: 0,
            select: [
                { name: '完整显示', value: 0 },
                { name: '简洁显示(不显示详细世系)', value: 1 },
                { name: '不显示', value: 2 }
            ]
        },
        titleContent: {
            title: '排版方向',
            value: 0,
            select: [
                { name: '横向', value: 0 },
                { name: '竖向', value: 1 }
            ]
        },
        page: {
            title: '页码样式',
            value: 0,
            select: [
                { name: '汉字数字', value: 0 },
                { name: '阿拉伯数字', value: 1 }
            ]
        }
    },
    headSettings: {
        note: {
            title: '标题显示',
            value: 0,
            select: [
                { name: '显示默认标题', value: 0 },
                { name: '仅单数页显示标题', value: 1 },
                { name: '不显示', value: 2 }
            ]
        },
        titleContent: {
            title: '标题内容（暂适用于欧式）',
            value: 0,
            select: [
                { name: '谱眉标题 + 世系', value: 0 },
                { name: '分房标题 + 世系', value: 1 },
                { name: '谱眉标题', value: 2 },
                { name: '分房标题', value: 3 },
                { name: '系统默认', value: 4 }
            ]
        },
        pageNum: {
            title: '页码类型',
            value: 0,
            select: [
                { name: '双面双页码', value: 0 },
                { name: '双面单页码', value: 1 },
                { name: '不显示', value: 2 }
            ]
        }
    },
    searchSettings: {
        note: {
            title: '显示纲旁注',
            value: 0,
            select: [
                { name: '显示(显示在人名后)', value: 0 },
                { name: '不显示', value: 1 }
            ]
        },
        title: {
            title: '标题显示位置',
            value: 0,
            select: [
                { name: '侧边竖排', value: 0 },
                { name: '居中横排', value: 1 }
            ]
        },
        daughter: {
            title: '显示女儿',
            value: 0,
            select: [
                { name: '显示', value: 0 },
                { name: '不显示', value: 1 }
            ]
        }
    },
    lineSettings: {
        pedigreePage: {
            title: '每页显示世系数',
            value: 0,
            select: [
                { name: '是(每页重复)', value: 0 },
                { name: '否(仅首次显示)', value: 1 }
            ]
        },
        aliasNameNote: {
            title: '将字号(别名)作为纲旁注',
            value: 0,
            select: [
                { name: '是', value: 0 },
                { name: '否', value: 1 }
            ]
        },
        spouse: {
            title: '显示配偶',
            value: 0,
            select: [
                { name: '显示', value: 0 },
                { name: '不显示', value: 1 }
            ]
        },
        daughter: {
            title: '显示所有女儿',
            value: 0,
            select: [
                { name: '是(优先于显示位置)', value: 0 },
                { name: '否(使用显示设置)', value: 1 }
            ]
        },
        personPage: {
            title: '人物页码显示',
            value: 0,
            select: [
                { name: '名字下方(阿拉伯数字)', value: 0 },
                { name: '名字旁边(中文数字, 适用于五世竖排)', value: 1 },
                { name: '隐藏', value: 2 }
            ]
        },
        pageNote: {
            title: '显示页码图标',
            value: 0,
            select: [
                { name: '显示', value: 0 },
                { name: '小于1000页显示', value: 1 },
                { name: '不显示', value: 2 }
            ]
        },
        level: {
            title: '显示排行',
            value: 0,
            select: [
                { name: '显示', value: 0 },
                { name: '不显示', value: 1 }
            ]
        }
    },
    sourceNote: {
        pedigree: {
            title: '显示世系数',
            value: 0,
            select: [
                { name: '显示', value: 0 },
                { name: '不显示', value: 1 }
            ]
        }
    },
    biographySettings: {
        dateTime: {
            title: '日期格式',
            value: 0,
            select: [
                { name: '一八九八年一月七日', value: 0 },
                { name: '一八九八年正月初七', value: 1 },
                { name: '光绪二十四年正月初七', value: 2 },
                { name: '光绪戊戌年正月初七', value: 3 },
                { name: '光绪戊戌(1898)年正月初七', value: 4 },
                { name: '1898年01月07日', value: 5 },
                { name: '自定义', value: 6 }
            ]
        },
        chineseTime: {
            title: '农历月份格式',
            value: 0,
            select: [
                { name: '正月', value: 0 },
                { name: '冬月', value: 1 },
                { name: '腊月', value: 2 }
            ]
        },
        birthday: {
            title: '生日描述',
            value: 0,
            select: [
                { name: '生于在前(生于XX年XX月XX日XX时)', value: 0 },
                { name: '生在后(XX年XX月XX日XX时生)', value: 1 }
            ]
        },
        burialDay: {
            title: '过世日期描述',
            value: 0,
            select: [
                { name: '卒殁在前(卒于XX年XX月XX日XX时)', value: 0 },
                { name: '卒殁在后(XX年XX月XX日XX时卒)', value: 1 }
            ]
        },
        burialKey: {
            title: '过世关键字',
            value: 0,
            select: [
                { name: '殁', value: 0 },
                { name: '歿', value: 1 },
                { name: '卒', value: 2 },
                { name: '故', value: 3 }
            ]
        },
        burialKeyMode: {
            title: '卒殁关键字反色处理',
            value: 0,
            select: [
                { name: '不处理(正常显示)', value: 0 },
                { name: '仅匹配过世日期', value: 1 },
                { name: '全文匹配(包含生平 / 后注等)', value: 2 }
            ]
        },
        sonDisplay: {
            title: '生子描述',
            value: 0,
            select: [
                { name: '生子N(生子二，大明/二明)', value: 0 },
                { name: '生N子(生二子，大明/二明)', value: 1 },
                { name: '生子(生子，大明/二明)', value: 2 },
                { name: '子N(子二，大明/二明)', value: 3 },
                { name: '不显示(不自动生成生子列表)', value: 3 }
            ]
        },
        deathAge: {
            title: '享寿描述',
            value: 0,
            select: [
                { name: '系统自动(默认)', value: 0 },
                { name: '统一显示[寿XX]', value: 1 }
            ]
        },
        ranking: {
            title: '显示生子排行',
            value: 0,
            select: [
                { name: '显示', value: 0 },
                { name: '不显示', value: 1 }
            ]
        },
        rankingMode: {
            title: '生子排行关系显示',
            value: 0,
            select: [
                { name: '按录入排行显示(长子 / 次子 / 三子)', value: 0 },
                { name: '独生子显示[之子]', value: 1 },
                { name: '全部显示[之子]', value: 2 },
                { name: '子女独立排行(长子/次子，长女/次女)', value: 3 },
                { name: '不显示(适用于苏式)', value: 4 }
            ]
        },
        sonInLawRankingMode: {
            title: '非生子排行关系显示',
            select: [
                {
                    title: '嗣子显示为',
                    value: 0,
                    select: [
                        { name: '嗣子', value: 0 },
                        { name: '继子', value: 1 },
                        { name: '兼嗣', value: 2 },
                        { name: '之子', value: 3 },
                        { name: '以录入为准', value: 4 }
                    ]
                },
                {
                    title: '祧子显示为',
                    value: 0,
                    select: [
                        { name: '祧子', value: 0 },
                        { name: '继子', value: 1 },
                        { name: '兼祧', value: 2 },
                        { name: '之子', value: 3 },
                        { name: '以录入为准', value: 4 }
                    ]
                },
                {
                    title: '抚子显示为',
                    value: 0,
                    select: [
                        { name: '抚子', value: 0 },
                        { name: '养子', value: 1 },
                        { name: '继子', value: 2 },
                        { name: '螟蛉子', value: 3 },
                        { name: '招郎子', value: 4 },
                        { name: '之子', value: 5 },
                        { name: '以录入为准', value: 6 }
                    ]
                }
            ]
        },
        sonInLaw: {
            title: '承祧行传显示',
            value: 0,
            select: [
                { name: '完整显示(跟生子相同)', value: 0 },
                { name: '仅显示[详生父某某 兼祧为嗣]', value: 1 }
            ]
        },
        sonInLawBiography: {
            title: '出嗣行传显示',
            value: 0,
            select: [
                { name: '完整显示(跟生子相同)', value: 0 },
                { name: '仅显示[出继某某为嗣]', value: 1 }
            ]
        },
        aliasName: {
            title: '常用名表示方式',
            value: 0,
            select: [
                { name: '又名XX', value: 0 },
                { name: '名XX', value: 1 }
            ]
        },
        spouseName: {
            title: '配偶名称显示',
            value: 0,
            select: [
                { name: '使用录入姓名', value: 0 },
                { name: '姓名前加身份(娶东郭村陈氏)', value: 1 },
                { name: '使用身份替换姓名(娶芳村陈员外之女)', value: 2 }
            ]
        },
        sentancePause: {
            title: '行传断句符号',
            value: 0,
            select: [
                { name: '空格(名张三 生于民国)', value: 0 },
                { name: '逗号(名张三，生于民国)', value: 1 },
                { name: '无(名张三生于民国)', value: 2 }
            ]
        },
        pedigreePage: {
            title: '每页显示世系数(适用于欧式/苏式)',
            value: 0,
            select: [
                { name: '是(每页显示)', value: 0 },
                { name: '否(每个世系仅显示一次)', value: 1 }
            ]
        },
        separateTitle: {
            title: '显示分房标题',
            value: 0,
            select: [
                { name: '显示', value: 0 },
                { name: '不显示', value: 1 }
            ]
        },
        separateTitleTopShow: {
            title: '分房标题置顶',
            value: 0,
            select: [
                { name: '是(不同分房时换页)', value: 0 },
                { name: '否', value: 1 }
            ]
        }
    }
}
